import ModelAttributeCard from '@components/model/details/ModelAttributeCard';
import ModelParametersList from '@components/model/details/ModelParametersList';
import DeviceModelFunctionalityList from '@components/model/deviceModel/DeviceModelFunctionalityList';
import DeviceModelProtocolDetail from '@components/model/deviceModel/DeviceModelProtocolDetail';
import { Chip, Typography } from '@destination/components';

import useDeviceModel from '@api/use-device-model';
import { IModel } from '@models/IModelBasic';

export interface IDeviceModelDetailBody {
  model: IModel;
}

export default function DeviceModelDetailBody({
  model
}: IDeviceModelDetailBody) {
  const { deviceModel, isLoading } = useDeviceModel(model);

  if (!deviceModel) {
    let message = 'No attributes provided!';
    if (isLoading) message = 'Loading attributes...';

    return <Typography className="px-3">{message}</Typography>;
  }

  return (
    <>
      <div
        className={
          'tw-rounded-md ml-5 mb-5 justify-center bg-slate-400 tw-bg-white tw-p-4 tw-shadow-[0_4px_20px_0_rgba(0,0,0,0.1)] tw-flex tw-items-center  p-2 pl-3'
        }
      >
        <span className="text-base font-bold">Category:</span>
        <Chip label={deviceModel.category} className="ml-4" />
      </div>
      {deviceModel.functionalities && (
        <ModelAttributeCard title="functionalities">
          <DeviceModelFunctionalityList
            data-testid="device-model-functionalities"
            functionalities={deviceModel.functionalities}
          />
        </ModelAttributeCard>
      )}
      {deviceModel.protocol && (
        <ModelAttributeCard title="protocol">
          <DeviceModelProtocolDetail
            data-testid="device-model-protocol"
            protocol={deviceModel.protocol}
          />
        </ModelAttributeCard>
      )}
      {deviceModel.specification_definitions &&
        deviceModel.specification_definitions.length > 0 && (
          <ModelAttributeCard title="specification_definitions">
            <ModelParametersList
              parameters={deviceModel.specification_definitions}
              data-testid="device-model-specification-definitions"
            />
          </ModelAttributeCard>
        )}
    </>
  );
}
